import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "https://modularobjects.com";

const API = `${API_BASE}/marketing/api/erp/documents`;

function authHeader(token) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export async function fetchDocuments(token, params = {}) {
  const res = await axios.get(API, {
    ...authHeader(token),
    params,
  });
  return res.data;
}

export async function fetchDocumentById(id, token) {
  const res = await axios.get(`${API}/${id}`, authHeader(token));
  return res.data;
}

export async function createDocument(payload, token) {
  const res = await axios.post(API, payload, authHeader(token));
  return res.data;
}

export async function updateDocument(id, payload, token) {
  const res = await axios.put(`${API}/${id}`, payload, authHeader(token));
  return res.data;
}

export async function submitDocument(id, token) {
  const res = await axios.post(`${API}/${id}/submit`, {}, authHeader(token));
  return res.data;
}

export async function approveDocument(id, token) {
  const res = await axios.post(`${API}/${id}/approve`, {}, authHeader(token));
  return res.data;
}

export async function postDocument(id, token) {
  const res = await axios.post(`${API}/${id}/post`, {}, authHeader(token));
  return res.data;
}

export async function cancelDocument(id, token) {
  const res = await axios.post(`${API}/${id}/cancel`, {}, authHeader(token));
  return res.data;
}